var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCalendarPartialDate = function SvgCalendarPartialDate(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.916748 5.04169C0.916748 3.77603 1.94276 2.75002 3.20841 2.75002H18.7917C20.0574 2.75002 21.0834 3.77603 21.0834 5.04169V18.7917C21.0834 20.0573 20.0574 21.0834 18.7917 21.0834H3.20841C1.94276 21.0834 0.916748 20.0573 0.916748 18.7917V5.04169ZM3.20841 4.58335C2.95528 4.58335 2.75008 4.78856 2.75008 5.04169V18.7917C2.75008 19.0448 2.95528 19.25 3.20841 19.25H18.7917C19.0449 19.25 19.2501 19.0448 19.2501 18.7917V5.04169C19.2501 4.78856 19.0449 4.58335 18.7917 4.58335H3.20841Z",
    fill: "#DE3121"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.87508 0.916687C7.38134 0.916687 7.79175 1.32709 7.79175 1.83335V5.50002C7.79175 6.00628 7.38134 6.41669 6.87508 6.41669C6.36882 6.41669 5.95841 6.00628 5.95841 5.50002V1.83335C5.95841 1.32709 6.36882 0.916687 6.87508 0.916687Z",
    fill: "#DE3121"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1251 0.916687C15.6313 0.916687 16.0417 1.32709 16.0417 1.83335V5.50002C16.0417 6.00628 15.6313 6.41669 15.1251 6.41669C14.6188 6.41669 14.2084 6.00628 14.2084 5.50002V1.83335C14.2084 1.32709 14.6188 0.916687 15.1251 0.916687Z",
    fill: "#DE3121"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0001 11.9167C11.7595 11.9167 12.3751 11.3011 12.3751 10.5417C12.3751 9.7823 11.7595 9.16669 11.0001 9.16669C10.2407 9.16669 9.62508 9.7823 9.62508 10.5417C9.62508 11.3011 10.2407 11.9167 11.0001 11.9167Z",
    fill: "#DE3121"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0417 11.9167C16.8011 11.9167 17.4167 11.3011 17.4167 10.5417C17.4167 9.7823 16.8011 9.16669 16.0417 9.16669C15.2824 9.16669 14.6667 9.7823 14.6667 10.5417C14.6667 11.3011 15.2824 11.9167 16.0417 11.9167Z",
    fill: "#DE3121"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.95841 16.9584C6.71781 16.9584 7.33341 16.3427 7.33341 15.5834C7.33341 14.824 6.71781 14.2084 5.95841 14.2084C5.19902 14.2084 4.58341 14.824 4.58341 15.5834C4.58341 16.3427 5.19902 16.9584 5.95841 16.9584Z",
    fill: "#DE3121"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0001 16.9584C11.7595 16.9584 12.3751 16.3427 12.3751 15.5834C12.3751 14.824 11.7595 14.2084 11.0001 14.2084C10.2407 14.2084 9.62508 14.824 9.62508 15.5834C9.62508 16.3427 10.2407 16.9584 11.0001 16.9584Z",
    fill: "#DE3121"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCalendarPartialDate, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/calendar-partial-date.886b8844.svg";
export { ForwardRef as ReactComponent };